enum TipoAnexoCarrossel {
  IMAGEM = 'I',
  VIDEO = 'V'
}

export default TipoAnexoCarrossel;
